
const colorListLength = ''
const merCustNo = ''
const hosCode = ''
const hosCardname = ''
const hosCardNo = ''
const cardType = ''
export default
{
  data () {
    return {
      merCustNo,
      colorListLength,
      hosCode,
      hosCardNo,
      hosCardname,
      cardType
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Global.vue